<template>
  <div class="ref-container">
    <router-view
      :key="$route.path"
      :viewPermission="viewPermission"
      :createPermission="createPermission"
      :editPermission="editPermission"
      :deletePermission="deletePermission"
    />

    <ExportOverlay />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import accessMix from '@/services/accessmix.js'
import ExportOverlay from '@/views/apps/referral-program/components/export/ExportOverlay.vue'

export default {
  mixins: [accessMix],
  components: {
    ExportOverlay,
  },
  computed: {
    ...mapState(['user']),
    viewPermission() {
      return this.checkPermissions(this.user.permissions, 'referral_program', 'view')
    },
    createPermission() {
      return this.checkPermissions(this.user.permissions, 'referral_program', 'create')
    },
    editPermission() {
      return this.checkPermissions(this.user.permissions, 'referral_program', 'edit')
    },
    deletePermission() {
      return this.checkPermissions(this.user.permissions, 'referral_program', 'delete')
    },
  },
}
</script>
